module.exports = "//static.hsappstatic.net/LoginUI/static-1.8304/img/unsupported-browser.svg"